import React, { useState, useEffect } from "react";
import UploadedCopy from "./UploadedCopy";
import ConfirmSection from "./ConfirmSection";
import Guarantor from "./Guarantor";
import WifeIndentification from "./WifeIndentification";
import RiderIdenfification from "./RiderIdenfification";
import BasicInformation from "./BasicInformation";
import YourIncome from "./ YourIncome";
import ParentInformation from "./ParentInformation";
import PaymentInformation from "./PaymentInformation";
import { Button, message, Spin, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAsyncProvinces,
  getAgent,
  setRiderPhoneNumber,
} from "../../redux/transactions/UntappedSlice";
import { motion, AnimatePresence } from "framer-motion";
import SuccessMessage from "./SuccessMessage";
import CustomStep from "./CustomStep";
import PaymentService from "./paymentService";
import PaymentStatusModal from "./PaymentStatusChecker";

const MultiStepForm = () => {
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  const loggedInAgent = useSelector(getAgent);
  const paymentService = new PaymentService();

  const motariStaggingUrl = "https://applicationbackend.jalikoi.rw/api/v2";
  const motarFileUrl = "https://applicationbackend.jalikoi.rw/api/v1";

  const stepVariants = {
    initial: { opacity: 0, x: 50 },
    animate: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    exit: { opacity: 0, x: -50, transition: { duration: 0.3, ease: "easeIn" } },
  };

  const STEP_TITLES = {
    1: "UMWIRONDORO W'UMUMOTARI",
    2: "AMAKURU Y'IBANZE",
    3: "AMAKURU AJYANYE NUKO WINJIZA",
    4: "UMWIRONDORO W'UWO MWASHAKANYE", // Only shown if married
    5: "AMAKURU Y'ABABYEYI", // Only shown if not married
    6: "IMYIRONDORO Y'UMWISHINGIZI",
    7: "AMAKURU Y'UMUGEREKA",
    8: "INJIZA COPY Z'IBYANGOBWA BYASABWE",
    9: "AMAKURU Y'UBWISHYU",
    10: "KWEMEZA AMAKURU YOSE Y'UMUMOTARI"
  };


  const [currentStep, setCurrentStep] = useState(1);
  const [darkMode, setDarkMode] = useState(true);
  const [isConfirmedSent, setIsConfirmedSent] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentApplicant, setCurrentApplicant] = useState("");

  // Payment states
  const [paymentModal, setPaymentModal] = useState({
    visible: false,
    status: 'pending',
    attempts: 0,
    maxAttempts: 40,
  });
  const [transactionId, setTransactionId] = useState("");

  // File states
  const [uploadedIDFile, setuploadedIDFile] = useState("");
  const [uploadedFile, setuploadedFile] = useState("");
  const [file_YELLOW_CARD, setfile_YELLOW_CARD] = useState("");
  const [file_CONTRACT, setfile_CONTRACT] = useState("");
  const [file_BUSINESS_CERTIFICATE, setfile_BUSINESS_CERTIFICATE] = useState("");

  // Form data states with localStorage initialization
  const [riderBasicInformation, setRiderBasicInformation] = useState(() => {
    return JSON.parse(localStorage.getItem("riderBasicInformation")) || {};
  });
  const [riderIdentification, setRiderIdentification] = useState(() => {
    return JSON.parse(localStorage.getItem("riderIdentification")) || {};
  });
  const [incomeData, setIncomeData] = useState(() => {
    return JSON.parse(localStorage.getItem("incomeData")) || {};
  });
  const [wifeIdentifications, setWifeIdentifications] = useState(() => {
    return JSON.parse(localStorage.getItem("wifeIdentifications")) || {};
  });
  const [parentInformation, setParentInformation] = useState(() => {
    return JSON.parse(localStorage.getItem("parentInformation")) || {};
  });
  const [guarantor, setGuarantor] = useState(() => {
    return JSON.parse(localStorage.getItem("guarantor")) || {};
  });
  const [customStep, setCustomStep] = useState(() => {
    return JSON.parse(localStorage.getItem("customStep")) || {};
  });
  const [paymentInformation, setPaymentInformation] = useState(() => {
    return JSON.parse(localStorage.getItem("paymentInformation")) || {};
  });
  const [uploadedCopies, setUploadedCopies] = useState(() => {
    return {};
  });

  // Change handlers (keep existing handlers)
  const handleBasicInformationChange = (formData) => {
    setRiderBasicInformation(formData);
  };

  const handleRiderIdentificationChange = (formData) => {
    if (formData.phone) {
      dispatch(setRiderPhoneNumber(formData.phone));
    }
    setRiderIdentification(formData);
  };

  const HandleIncomeData = (formData) => {
    setIncomeData(formData);
  };

  const handleWifeIdentificationChange = (formData) => {
    setWifeIdentifications(formData);
  };

  const handleParentInformationChange = (formData) => {
    setParentInformation(formData);
  };

  const handleGuarantorChange = ({
    guarantorsData,
    uploadedFile,
    uploadedIDFile,
    file_YELLOW_CARD,
    file_CONTRACT,
    file_BUSINESS_CERTIFICATE,
  }) => {
    if (uploadedFile) setuploadedFile(uploadedFile);
    if (uploadedIDFile) setuploadedIDFile(uploadedIDFile);
    if (file_YELLOW_CARD) setfile_YELLOW_CARD(file_YELLOW_CARD);
    if (file_CONTRACT) setfile_CONTRACT(file_CONTRACT);
    if (file_BUSINESS_CERTIFICATE) setfile_BUSINESS_CERTIFICATE(file_BUSINESS_CERTIFICATE);
    setGuarantor(guarantorsData);
  };

  const handleCustomStepChange = (formData) => {
    setCustomStep(formData);
  };

  const handlePaymentInformationChange = (formData) => {
    setPaymentInformation(formData);
  };

  const handleUploadedCopiesChange = (formData) => {
    setUploadedCopies(formData);
  };

  const handleConfirmChange = async (checked) => {
    setIsConfirmed(checked);
  };

  const resetApplicationForm = () => {
    setIsSubmitting(false);
    setCurrentStep(1);
    setIsConfirmedSent(false);
    setUploadProgress(0);
    setTransactionId("");
    localStorage.clear();
    window.location.replace("/jali-application-form");
  };

  const createFormData = async () => {
    setIsSubmitting(true);
    setUploadProgress(0);

    const formData = new FormData();
    const fileAttributes = {
      file_PHOTO: uploadedCopies.profileImage?.originFileObj,
      file_ID: uploadedCopies.nationalIdCopy?.originFileObj,
      file_LETTER: uploadedCopies.loanApplicationLetter?.originFileObj,
      file_DRIVING_LICENCY: uploadedCopies.drivingLicenseCopy?.originFileObj,
      file_RECEIPT: uploadedCopies.paymentReceipt?.originFileObj,
      file_MARITAL_STATUS: uploadedCopies.maritalStatusProof?.originFileObj,
      file_VILLAGE: uploadedCopies.residenceProof?.originFileObj,
      file_INSURER_ID: uploadedIDFile,
      file_MOTARI_INSURANCE: uploadedCopies.motorInsuranceCopy?.originFileObj || null,
      file_YELLOW_CARD: file_YELLOW_CARD?.originFileObj,
      file_CONTRACT: file_CONTRACT?.originFileObj,
      file_BUSINESS_CERTIFICATE: file_BUSINESS_CERTIFICATE?.originFileObj,
    };

    Object.entries(fileAttributes).forEach(([key, file]) => {
      if (file) {
        formData.append(key, file);
      }
    });

    try {
      const uploadResponse = await axios.post(
        `${motarFileUrl}/upload/${currentApplicant}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          },
        }
      );

      setUploadProgress(100);
      api.success({
        message: 'Igikorwa Cyagenze Neza',
        description: 'Igikorwa cyagenze neza! Komeza ku cyiciro gikurikiraho.',
        placement: 'topRight',
        duration: 5,
      });

      setTimeout(() => {
        nextStep();
        setUploadProgress(0);
        setIsSubmitting(false);
      }, 500);
    } catch (error) {
      setIsSubmitting(false);
      setUploadProgress(0);
      message.error(error.response?.data?.message || "Amakuru watanze si yo. Nyamuneka wongere ugenzure.");
    }
  };

  /**
   * Handle payment initiation and status checking
   */
  const handlePaymentStep = async () => {
    const isMomoPayment = paymentService.isMobileMoneyPayment(paymentInformation?.type);

    if (!isMomoPayment) {
      // For non-MoMo payments, proceed normally
      return await submitStepData();
    }

    // Initiate mobile money payment
    setIsSubmitting(true);

    try {
      const paymentResult = await paymentService.initiatePayment({
        applicant_id: currentApplicant,
        type: paymentInformation?.type,
        phone: paymentInformation?.phone,
        file_id: paymentInformation?.fileId,
      });

      if (!paymentResult.success) {
        setIsSubmitting(false);
        nextStep();
        throw new Error(paymentResult.message);
      }

      // Store transaction ID
      const txnId = paymentResult.transaction_id || paymentResult.data?.transaction_id;
      const alreadyPaid = paymentResult?.data?.payment_status === "ALREADY_PAID";




      if (!txnId && !alreadyPaid) {
        setIsSubmitting(false);
        throw new Error("Transaction ID not received from server");
      }
      if (!txnId && alreadyPaid) {
        setIsSubmitting(false);
        nextStep();
        throw new Error(paymentResult.message);
      }

      setTransactionId(txnId);

      // Payment initiation successful - now show modal and start checking status
      api.info({
        message: 'Ubwishyu Bwatangijwe',
        description: 'Ubwishyu bwatangijwe. Emeza kuri telefoni yawe.',
        placement: 'topRight',
        duration: 3,
      });

      // Show payment status modal BEFORE starting to poll
      setPaymentModal({
        visible: true,
        status: 'pending',
        attempts: 0,
        maxAttempts: 40,
      });

      setIsSubmitting(false);

      // Start polling payment status
      const statusResult = await paymentService.pollPaymentStatus(
        currentApplicant,
        txnId,
        {
          interval: 3000,
          maxAttempts: 40,
          onStatusUpdate: (status, attempts) => {
            setPaymentModal(prev => ({
              ...prev,
              attempts,
            }));
          },
        }
      );

      if (statusResult.success) {
        // Payment completed successfully
        setPaymentModal(prev => ({
          ...prev,
          status: 'completed',
        }));

        api.success({
          message: 'Ubwishyu Bwarangiye',
          description: statusResult.message,
          placement: 'topRight',
          duration: 3,
        });

        // Wait 2 seconds then proceed to next step
        setTimeout(() => {
          setPaymentModal({ visible: false, status: 'pending', attempts: 0, maxAttempts: 40 });
          nextStep();
        }, 2000);
      } else {
        // Payment failed or timeout
        setPaymentModal(prev => ({
          ...prev,
          status: 'failed',
        }));

        api.error({
          message: 'Ubwishyu Ntibyagenze',
          description: statusResult.message,
          placement: 'topRight',
          duration: 5,
        });
      }
    } catch (error) {
      setIsSubmitting(false);
      setPaymentModal({ visible: false, status: 'pending', attempts: 0, maxAttempts: 40 });
      api.error({
        message: 'Ikosa Ryabaye',
        description: error.message || "Habayeho ikosa. Ongera ugerageze.",
        placement: 'topRight',
      });
    }
  };

  const getStepPayload = () => {
    if (!currentStep) return {};

    switch (currentStep) {
      case 1:
        return {
          step: 1,
          applicant_id: currentApplicant || "",
          first_name: riderIdentification.firstName ?? "",
          last_name: riderIdentification.lastName ?? "",
          dob: riderIdentification.birthDate ?? "",
          phone: riderIdentification.phone ?? "",
          nid: riderIdentification.idNumber ?? "",
          gender: riderIdentification.gender ?? "",
          branch_id: riderIdentification.branch ?? "",
          email: riderIdentification.email ?? "",
          place_of_birth: riderIdentification.village
            ? parseInt(riderIdentification.village, 10)
            : "",
        };

      case 2:
        return {
          step: 2,
          applicant_id: currentApplicant,
          status: riderBasicInformation.maritalStatus ?? "",
          residence: {
            village_id: riderBasicInformation.village
              ? parseInt(riderBasicInformation.village, 10)
              : "",
          },
          driving_licency: riderBasicInformation.licenseNumber ?? "",
          driving_licency_issued_date: riderBasicInformation.issuedDate ?? "",
          home_ownership: riderBasicInformation.houseOwnership ?? "",
          monthly_rent: riderBasicInformation.rent_amount ?? "",
          rent_duration: `${riderBasicInformation.duration?.value ?? ""} ${riderBasicInformation.duration?.type ?? ""}`,
        };

      case 3:
        return {
          step: 3,
          applicant_id: currentApplicant,
          moto_experience: `${incomeData.motariDuration?.value ?? ""} ${incomeData.motariDuration?.type ?? ""}`,
          moto_ownership: incomeData.motoOwnership ?? "",
          debts: incomeData.hasDebt ?? "",
          loan_payment_process: "Buri Cyumweru",
          moto_id: parseInt(incomeData?.preferredMotoType?.id ?? "0", 10),
          daily_income: parseInt(incomeData.dailyIncome ?? "0", 10),
        };

      case 4:
        return {
          step: 4,
          applicant_id: currentApplicant,
          first_name: wifeIdentifications?.firstName || "",
          last_name: wifeIdentifications?.lastName || "",
          phone: wifeIdentifications?.phoneNumber || "",
          nid: wifeIdentifications?.idNumber || "",
          occupation: wifeIdentifications?.occupation || "",
        };

      case 5:
        return {
          step: 5,
          applicant_id: currentApplicant,
          name: parentInformation?.parentName || "",
          phone: parentInformation?.parentPhone || "",
          national_id: parentInformation?.parentNationalId || "",
        };

      case 6:
        const { insurer_one } = guarantor || {};
        return {
          step: 6,
          applicant_id: currentApplicant,
          identity: insurer_one?.nationalId || "",
          first_name: insurer_one?.firstName || "",
          last_name: insurer_one?.lastName || "",
          occupation: insurer_one?.occupation || "",
          phone: insurer_one?.phoneNumber || "",
          gender: "FEMALE",
          residence: {
            village_id: insurer_one?.village
              ? parseInt(insurer_one.village, 10)
              : null,
          },
        };

      case 7:
        return {
          step: 7,
          applicant_id: currentApplicant,
          moto_id: parseInt(incomeData?.preferredMotoType?.id ?? "0", 10),
          extra_values: customStep || "",
        };

      case 8:
        return {
          step: 8,
          fileData: uploadedCopies,
          applicant_id: currentApplicant,
        };

      case 9:
        return {
          step: 8,
          applicant_id: currentApplicant,
          type: paymentInformation?.type || "",
          phone: paymentInformation?.phone || "",
          file_id: paymentInformation?.fileId || "",
        };

      case 10:
        return {
          step: 9,
          applicant_id: currentApplicant,
          terms_condition: isConfirmed,
          agent_id: loggedInAgent?.id || "",
        };

      default:
        return {};
    }
  };

  const submitStepData = async () => {
    if (isSubmitting) return;

    // Handle file upload step
    if (currentStep === 8) {
      await createFormData();
      return;
    }

    // Handle payment step with MoMo
    if (currentStep === 9 && paymentService.isMobileMoneyPayment(paymentInformation?.type)) {
      await handlePaymentStep();
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = getStepPayload();

      const response = await fetch(
        `${motariStaggingUrl}/application/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        if (currentStep === 10) {
          api.success({
            message: 'Igikorwa Cyagenze Neza',
            description: 'Igikorwa cyagenze neza! Murakoze',
            placement: 'topRight',
            duration: 5,
          });
          setIsConfirmedSent(true);
        } else {
          api.success({
            message: 'Igikorwa Cyagenze Neza',
            description: 'Igikorwa cyagenze neza! Komeza ku cyiciro gikurikiraho.',
            placement: 'topRight',
            duration: 5,
          });

          nextStep();
          setCurrentApplicant(responseData.applicant_id);
        }
        setIsSubmitting(false);
        return true;
      } else {
        if (currentStep === 10) {
          let errorMessage = null;

          if (typeof responseData.errors?.message === 'string') {
            errorMessage = responseData.errors.message;
          } else if (typeof responseData.message === 'string') {
            errorMessage = responseData.message;
          } else {
            errorMessage = "Habayeho ikosa. Ongera ugerageze.";
          }

          api.error({
            message: 'Ikosa Ryabaye',
            description: errorMessage,
            placement: 'topRight',
            duration: 10,
          });

          if (responseData.errors?.incomplete_steps?.length > 0) {
            const incompleteStep = responseData.errors.incomplete_steps[0];
            setTimeout(() => {
              setCurrentStep(incompleteStep + 1);
            }, 2000);
          }

          setIsSubmitting(false);
        } else {
          setIsSubmitting(false);

          if (responseData?.message) {
            api.error({
              message: 'Ikosa Ryabaye',
              description: responseData.message,
              placement: 'topRight',
              duration: 10,
            });
          }
          if (responseData?.errors) {
            Object.entries(responseData.errors).forEach(([key, value]) => {
              api.error({
                message: 'Ikosa Ryabaye',
                description: value,
                placement: 'topRight',
                duration: 10,
              });
            });
          }
          return false;
        }
      }
    } catch (error) {
      setIsSubmitting(false);
      api.error({
        message: 'Ikosa Ryabaye',
        description: "Amakuru watanze si yo. Nyamuneka wongere ugenzure",
        placement: 'topRight',
      });
      return false;
    }
  };

  // Update the nextStep function to skip ParentInformation when married
  const nextStep = () => {
    const selectedCategory = incomeData?.preferredMotoType || null;
    const hasExtraFields = selectedCategory && selectedCategory.extra;
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED" || riderBasicInformation.maritalStatus === "NARASHATSE";

    if (currentStep === 4 && !isMarried) {
      // Skip wife info step if not married
      console.log("Skipping wife info step");
      setCurrentStep(5);
    } else if (currentStep === 4 && isMarried) {
      // If married, skip ParentInformation and go directly to Guarantor
      console.log("Married - skipping parent info step");
      setCurrentStep(6);
    } else if (currentStep === 3 && isMarried) {
      // From income step, if married go to wife info
      setCurrentStep(4);
    } else if (currentStep === 3 && !isMarried) {
      // From income step, if not married go to parent info
      setCurrentStep(5);
    } else if (currentStep === 6) {
      if (hasExtraFields && Object.keys(selectedCategory.extra).length > 0) {
        setCurrentStep(7);
      } else {
        setCurrentStep(8);
      }
    } else if (currentStep === 7 && !hasExtraFields) {
      setCurrentStep(8);
    } else {
      setCurrentStep((prev) => Math.min(prev + 1, 10));
    }
  };


  const previousStep = () => {
    if (isSubmitting) return;

    const selectedCategory = incomeData?.preferredMotoType || null;
    const hasExtraFields = selectedCategory && selectedCategory.extra;
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED" || riderBasicInformation.maritalStatus === "NARASHATSE";

    if (currentStep === 9 && !hasExtraFields) {
      setCurrentStep(6);
    } else if (currentStep === 8 && !hasExtraFields) {
      setCurrentStep(6);
    } else if (currentStep === 6 && isMarried) {
      // If married, go back to wife info step
      setCurrentStep(4);
    } else if (currentStep === 5 && !isMarried) {
      // If not married, go back to income step
      setCurrentStep(3);
    } else {
      setCurrentStep((prev) => Math.max(prev - 1, 1));
    }
  };



  useEffect(() => {
    localStorage.setItem("riderBasicInformation", JSON.stringify(riderBasicInformation));
    localStorage.setItem("riderIdentification", JSON.stringify(riderIdentification));
    localStorage.setItem("incomeData", JSON.stringify(incomeData));
    localStorage.setItem("wifeIdentifications", JSON.stringify(wifeIdentifications));
    localStorage.setItem("parentInformation", JSON.stringify(parentInformation));
    localStorage.setItem("guarantor", JSON.stringify(guarantor));
    localStorage.setItem("customStep", JSON.stringify(customStep));
    localStorage.setItem("paymentInformation", JSON.stringify(paymentInformation));
  }, [
    riderBasicInformation,
    riderIdentification,
    incomeData,
    wifeIdentifications,
    parentInformation,
    guarantor,
    customStep,
    paymentInformation,
  ]);

  useEffect(() => {
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED" || riderBasicInformation.maritalStatus === "NARASHATSE";

    // Skip wife info step if not married
    if (currentStep === 4 && !isMarried) {
      setCurrentStep(5);
    }

    // Skip parent info step if married
    if (currentStep === 5 && isMarried) {
      setCurrentStep(6);
    }
  }, [currentStep, riderBasicInformation.maritalStatus]);

  useEffect(() => {
    dispatch(fetchAsyncProvinces());
  }, [dispatch]);

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const calculateProgress = () => {
    const isMarried = riderBasicInformation.maritalStatus === "MARRIED" || riderBasicInformation.maritalStatus === "NARASHATSE";
    const selectedCategory = incomeData?.preferredMotoType || null;
    const hasExtraFields = selectedCategory && selectedCategory.extra;

    let totalSteps = 10;

    // Subtract skipped steps
    if (isMarried) totalSteps -= 1; // Skip parent info
    if (!isMarried) totalSteps -= 1; // Skip wife info
    if (!hasExtraFields) totalSteps -= 1; // Skip custom step

    // Adjust current step based on skipped steps
    let adjustedStep = currentStep;
    if (isMarried && currentStep > 4) adjustedStep -= 1;
    if (!hasExtraFields && currentStep > 6) adjustedStep -= 1;

    return Math.round((adjustedStep / totalSteps) * 100);
  };

  return (
    <div
      className={`min-h-screen flex flex-col items-center transition-colors duration-300 w-full ${darkMode
        ? "bg-gradient-to-br from-[#151f3b] via-[#20409A] to-[#192853] text-white"
        : "bg-[#20409A] text-white"
        }`}
    >
      {contextHolder}
      <h2
        className={`text-lg sm:text-xl md:text-2xl lg:text-2xl font-bold py-4 text-center ${darkMode ? "text-white" : "bg-[#20409A] text-white"
          }`}
      >
        <span className="inline-block text-lg">
          UZUZA UMWIRONDORO W'UMUMOTARI USHAKA INGUZANYO YA MOTO 
        </span>{" "}
        {/* <br />
        <span className="inline-block">JALI FINANCE Ltd</span> */}
      </h2>

      {/* Payment Status Modal */}
      <PaymentStatusModal
        visible={paymentModal.visible}
        status={paymentModal.status}
        attempts={paymentModal.attempts}
        maxAttempts={paymentModal.maxAttempts}
        onCancel={() => setPaymentModal({ visible: false, status: 'pending', attempts: 0, maxAttempts: 40 })}
      />

      {!isConfirmedSent && (
        <div className="w-full max-w-xl p-6 bg-gradient-to-br from-gray-900/50 to-gray-900/50 rounded-2xl shadow-lg">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium">
              Icyiciro {currentStep} cya 10
            </span>
            <span className="text-sm font-medium">
              {calculateProgress()}%
            </span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-2 mb-3">
            <div
              className="bg-blue-500 h-2 rounded-full transition-all duration-300"
              style={{ width: `${calculateProgress()}%` }}
            />
          </div>

          <div className="flex justify-between items-center mb-4">
            <h1 className="text-lg font-semibold uppercase">
              {STEP_TITLES[currentStep]}
            </h1>
          </div>

          {isSubmitting && !paymentModal.visible && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-8 max-w-sm mx-4 text-center">
                <Spin indicator={antIcon} size="large" />
                <p className="mt-4 text-gray-700 font-medium">
                  {currentStep === 8 ? "Ohereza dosiye..." : "Ohereza amakuru..."}
                </p>
                {currentStep === 8 && uploadProgress > 0 && (
                  <div className="mt-4">
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${uploadProgress}%` }}
                      />
                    </div>
                    <p className="mt-2 text-sm text-gray-600">{uploadProgress}%</p>
                  </div>
                )}
              </div>
            </div>
          )}

          <AnimatePresence mode="wait">
            {currentStep === 1 && (
              <motion.div key="step1" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <RiderIdenfification
                  data={riderIdentification}
                  onChangeHandleRinderInfo={handleRiderIdentificationChange}
                />
              </motion.div>
            )}

            {currentStep === 2 && (
              <motion.div key="step2" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <BasicInformation
                  data={riderBasicInformation}
                  basicInformation={handleBasicInformationChange}
                />
              </motion.div>
            )}

            {currentStep === 3 && (
              <motion.div key="step3" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <YourIncome
                  data={incomeData}
                  transmission={incomeData && incomeData.preferredMotoType?.id}
                  HandleIncomeData={HandleIncomeData}
                />
              </motion.div>
            )}

            {currentStep === 4 && riderBasicInformation.maritalStatus === "MARRIED" && (
              <motion.div key="step4" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <WifeIndentification
                  data={wifeIdentifications}
                  onChangeWifeIdentifications={handleWifeIdentificationChange}
                />
              </motion.div>
            )}

            {currentStep === 5 && (
              <motion.div key="step5" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <ParentInformation
                  data={parentInformation}
                  onChangeParentInfo={handleParentInformationChange}
                />
              </motion.div>
            )}

            {currentStep === 6 && (
              <motion.div key="step6" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <Guarantor
                  data={guarantor}
                  bikeType={incomeData && incomeData.preferredMotoType?.transmission}
                  onChange={handleGuarantorChange}
                />
              </motion.div>
            )}

            {currentStep === 7 && (
              <motion.div key="step7" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <CustomStep
                  data={customStep}
                  preferredMotoType={incomeData && incomeData.preferredMotoType}
                  onChangeCustomStep={handleCustomStepChange}
                />
              </motion.div>
            )}

            {currentStep === 8 && (
              <motion.div key="step8" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <UploadedCopy
                  data={uploadedCopies}
                  onChange={handleUploadedCopiesChange}
                />
              </motion.div>
            )}

            {currentStep === 9 && (
              <motion.div key="step9" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <PaymentInformation
                  currentApplicant={currentApplicant}
                  data={paymentInformation}
                  onChangePaymentInfo={handlePaymentInformationChange}
                />
              </motion.div>
            )}

            {currentStep === 10 && (
              <motion.div key="step10" variants={stepVariants} initial="initial" animate="animate" exit="exit">
                <ConfirmSection
                  isConfirmed={isConfirmed}
                  onConfirmChange={handleConfirmChange}
                />
              </motion.div>
            )}
          </AnimatePresence>

          <div className="flex justify-between mt-6">
            <div>
              {currentStep > 1 && (
                <Button
                  type="default"
                  onClick={previousStep}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg flex items-center hover:bg-gray-300"
                  disabled={currentStep === 1 || isSubmitting}
                >
                  Ahabanza
                </Button>
              )}
            </div>
            <div className="flex space-x-4">
              {currentStep < 10 && (
                <Button
                  type="primary"
                  onClick={submitStepData}
                  loading={isSubmitting}
                  className="px-4 py-2 bg-blue-900 text-white rounded-lg flex items-center hover:bg-blue-800"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Ohereza..." : "Komeza"}
                </Button>
              )}

              {currentStep === 10 && (
                <Button
                  type="primary"
                  disabled={!isConfirmed || isSubmitting}
                  onClick={submitStepData}
                  loading={isSubmitting}
                  className="px-4 py-2 bg-blue-900 text-white rounded-lg flex items-center hover:bg-blue-800"
                >
                  {isSubmitting ? "Ohereza..." : "Iyandikishe"}
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {isConfirmedSent && (
        <div className="w-full max-w-xl p-6 bg-gradient-to-br from-gray-900/50 to-gray-900/50 rounded-2xl shadow-lg">
          <SuccessMessage />
          <Button
            className="text-white mx-6 mt-4 bg-blue-900 hover:bg-blue-800"
            onClick={resetApplicationForm}
          >
            Reset form
          </Button>
        </div>
      )}
    </div>
  );
};

export default MultiStepForm;
